const locale = navigator.language || 'it-IT';
const [langCode, countryCode] = locale.split('-');

export const getLocales = () => [
  {
    languageCode: langCode || 'it',
    countryCode: countryCode || 'IT',
    languageTag: locale,
    isRTL: false,
    scriptCode: null,
    currencyCode: countryCode === 'IT' ? 'EUR' : undefined,
    currencySymbol: countryCode === 'IT' ? '€' : undefined,
    decimalSeparator: ',',
    digitGroupingSeparator: '.',
  },
];

export const getNumberFormatSettings = () => ({
  decimalSeparator: ',',
  groupingSeparator: '.',
});

export const getCurrencies = () => [countryCode === 'IT' ? 'EUR' : 'USD'];

export const getCountry = () => countryCode || 'IT';

export const getCalendar = () => 'gregorian';

export const getTemperatureUnit = () => 'celsius';

export const getTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const uses24HourClock = () => true;

export const usesMetricSystem = () => true;

export const usesAutoDateAndTime = () => null;

export const usesAutoTimeZone = () => null;

export const findBestLanguageTag = (languages) => {
  if (!languages || languages.length === 0) return null;
  return { languageTag: languages[0], isRTL: false };
};

export const addEventListener = (_event, _handler) => ({ remove: () => {} });
export const removeEventListener = () => {};
